import {Injectable} from '@angular/core';
import {Socket} from 'ngx-socket-io';

@Injectable()
export class SocketServices {
  constructor(private socket: Socket) {
    this.socket.on('connect', (e) => {
      console.log('conectado');
    });
  }

  enviarEvento(evento: string, datos: any) {
    this.socket.emit(evento, datos);
  }

  registrarEvento(evento:string){
    return this.socket.fromEvent<any>(evento);
  }
}
